import classifications, {
    initialState as initialClassifications,
} from './classifications/DataStoreClassifications.reducer';

import { types as AuthActionTypes } from '/b2b/authentication/state/Auth.actions';
import { combineReducers } from 'redux';
import { genericReducer } from '../../common/helpers/ReduxHelpers';
import reduceReducers from 'reduce-reducers';

export const initialState = {
    classifications: initialClassifications,
};

export default reduceReducers(
    initialState,
    combineReducers({
        classifications,
    }),
    genericReducer(initialState, {
        [AuthActionTypes.logout]: () => initialState,
    })
);
